module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('v-app', [_c('v-content', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-progress-circular', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "indeterminate": ""
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('h4', [_vm._v(" Resend Token to user? ")])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("\n                  Cancel\n                ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.resend(_vm.item)
      }
    }
  }, [_vm._v("\n                  Confirm\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.notifications,
      "pagination": _vm.pagination
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.username))]), _vm._v(" "), _c('td', [(props.item.sentStatus === 'TOKEN_SENT') ? _c('h6', {
          staticClass: "primary--text body-2"
        }, [_vm._v(" " + _vm._s(props.item.sentStatus) + " ")]) : _vm._e(), _vm._v(" "), (props.item.sentStatus === 'TOKEN_NOT_SENT') ? _c('p', {
          staticClass: "error--text body-2"
        }, [_vm._v(" " + _vm._s(props.item.sentStatus) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.createdAt))]), _vm._v(" "), _c('td', [_c('v-btn', {
          attrs: {
            "color": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.resendToken(props.item)
            }
          }
        }, [_vm._v(" Resend ")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('template', {
    slot: "no-data"
  }, [_c('p', [_vm._v(" No data Found ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.getTokenNotications
    }
  }, [_vm._v("Reload")])], 1)], 2), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "right": true,
      "bottom": true,
      "color": _vm.snackColor
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.snackmessage) + "\n          "), _c('v-btn', {
    attrs: {
      "color": "pink",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("\n            Close\n          ")])], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb9e4386"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/admin/usertokennotifications.vue
// module id = 1076
// module chunks = 2